import WebFontLoader from 'webfontloader'

// async load fonts
WebFontLoader.load({
  google: {
    families: [
      'Roboto:400,700&display=swap',
      'Roboto Condensed:100,300,400,500,700,900&display=swap',
    ],
  },
})
